import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconThrottle = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="M8 2c4.417 0 8 3.448 8 7.697a7.617 7.617 0 0 1-1.083 3.875.929.929 0 0 1-.778.428H1.833c-.305 0-.61-.16-.75-.428A7.354 7.354 0 0 1 0 9.697C0 5.447 3.583 2 8 2Zm4 3.42c-.5 0-.889.402-.889.856 0 .481.389.855.889.855.472 0 .889-.374.889-.855 0-.454-.417-.855-.889-.855ZM8 3.71c-.5 0-.889.401-.889.856 0 .48.389.855.889.855.472 0 .889-.374.889-.855 0-.455-.417-.856-.889-.856Zm-5.333 7.698c.472 0 .889-.375.889-.856 0-.454-.417-.855-.89-.855-.5 0-.888.401-.888.855 0 .481.389.856.889.856ZM4 7.13c.472 0 .889-.374.889-.855 0-.454-.417-.855-.889-.855-.5 0-.889.4-.889.855 0 .481.389.855.889.855Zm9.444 4.063a.618.618 0 0 0 .528-.722.656.656 0 0 0-.75-.534l-3.722.588A1.79 1.79 0 0 0 8 9.697c-1 0-1.778.775-1.778 1.71 0 .321.084.615.222.856h3.084c.083-.134.139-.294.194-.481l3.722-.588Z"
    />
  </svg>
));
export default SvgIconThrottle;
